module.exports = __webpack_public_path__ + "static/drone-video-optimized-bdffe14acf2bb4bbe937df20124b4746.mp4";